import { render, staticRenderFns } from "./CookiePopup.vue?vue&type=template&id=30b8798a&scoped=true&"
import script from "./CookiePopup.vue?vue&type=script&lang=js&"
export * from "./CookiePopup.vue?vue&type=script&lang=js&"
import style0 from "./CookiePopup.vue?vue&type=style&index=0&id=30b8798a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b8798a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Btn: require('/var/www/app/components/Btn.vue').default})
